import { useTheme } from "@emotion/react";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import AlertMessage from "components/react-lib/generic-ui/AlertMessage";
import LabelledOutline from "components/react-lib/generic-ui/LabelledOutline";
import HeaderCell from "components/table/HeaderCell";
import React from "react";
import FixedFees from "./FixedFees";
import Costs from "./Costs";

export default function GenericFees({ pricing }) {
  const theme = useTheme();

  const formatPrice = (price) => {
    return `${price.toFixed(4)} $`;
  };

  return (
    <Stack spacing={2}>
      <FixedFees pricing={pricing} />
      <Costs pricing={pricing} />
    </Stack>
  );
}
